import template from './leave-adjustments.html';
import controller from './leave-adjustments.controller';

let LeaveAdjustmentsModal = {
  animation: true,
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'md',
  windowClass: 'hmodal-info animated fadeIn leave-adjustments-modal'
};

export default LeaveAdjustmentsModal;




// WEBPACK FOOTER //
// ./client/pages/leave/modals/leave-adjustments/leave-adjustments.component.js